import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import tracker from '../service/tracker';
import Category from './Category';

const CategoryPage = ({ category, categorySlug }) => {
    useEffect(() => {
        tracker.initialize(category);
        tracker.view(categorySlug);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="category-page">
            <Category category={category} categorySlug={categorySlug}/>
        </div>
    );};

CategoryPage.propTypes = {
    category: PropTypes.object
};

export default CategoryPage;
